import React, { useEffect, useState } from 'react';
import { api } from '../../api';

function DoToDo() {
    // Modified: Initial state for dotodo and date is loaded from sessionStorage
    const [dotodo, setDotodo] = useState(
        () => sessionStorage.getItem('dotodoText') || ''
    );
    const [date, setDate] = useState(
        () => sessionStorage.getItem('dotodoDate') || ''
    );
    
    const [dotodos, setDotodos] = useState([]);
    const [editId, setEditId] = useState(null);

    // Initial fetch of todos
    useEffect(() => {
        fetchDotodos();
    }, []);

    // NEW: Save the dotodo text to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('dotodoText', dotodo);
    }, [dotodo]);

    // NEW: Save the date to sessionStorage whenever it changes
    useEffect(() => {
        sessionStorage.setItem('dotodoDate', date);
    }, [date]);

    const fetchDotodos = async () => {
        const res = await api.get('/');
        setDotodos(res.data);
    };

    const handleAdd = async () => {
        if (!dotodo || !date) return alert('Please fill both fields');
        await api.post('/', { dotodo, date });
        
        // Clear state and sessionStorage after successful addition
        setDotodo('');
        setDate('');
        sessionStorage.removeItem('dotodoText');
        sessionStorage.removeItem('dotodoDate');
        
        fetchDotodos();
    };

    const handleDelete = async (id) => {
        await api.delete(`/${id}`);
        fetchDotodos();
    };

    const handleEdit = (item) => {
        setDotodo(item.dotodo);
        setDate(item.date.slice(0, 10));
        setEditId(item._id);
    };

    const handleUpdate = async () => {
        await api.put(`/${editId}`, { dotodo, date });

        // Clear state and sessionStorage after successful update
        setDotodo('');
        setDate('');
        setEditId(null);
        sessionStorage.removeItem('dotodoText');
        sessionStorage.removeItem('dotodoDate');

        fetchDotodos();
    };

    const isDueToday = (dueDate) => {
        const today = new Date().toISOString().slice(0, 10);
        return dueDate.slice(0, 10) === today;
    };
    
  return (
    <div className="max-w-3xl mx-auto p-6">
      <h1 className="text-3xl font-bold text-center mb-6 text-white">📝 DoToDo Reminder</h1>

      <div className="bg-white p-4 rounded-xl shadow mb-6">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <input
            className="border border-gray-300 p-2 rounded"
            type="text"
            placeholder="Enter DoToDo"
            value={dotodo}
            onChange={(e) => setDotodo(e.target.value)}
          />
          <input
            className="border border-gray-300 p-2 rounded"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
          />
          {editId ? (
            <button
              className="bg-yellow-500 text-white rounded p-2 hover:bg-yellow-600 transition"
              onClick={handleUpdate}
            >
              Update
            </button>
          ) : (
            <button
              className="bg-blue-500 text-white rounded p-2 hover:bg-blue-600 transition"
              onClick={handleAdd}
            >
              Add
            </button>
          )}
        </div>
      </div>

      {dotodos.length === 0 ? (
        <p className="text-center text-gray-400 text-white">No DoToDos yet</p>
      ) : (
        <ul className="space-y-4">
          {dotodos.map((item) => (
            <li
              key={item._id}
              className="bg-white p-4 rounded-xl shadow flex flex-col md:flex-row justify-between items-start md:items-center"
            >
              <div>
                <p className="font-semibold">{item.dotodo}</p>
                <p className="text-sm text-gray-500">
                  Due: {new Date(item.date).toLocaleDateString()}
                  {isDueToday(item.date) && !item.reminded && (
                    <span className="text-red-600 font-medium ml-2">🔔 Due Today</span>
                  )}
                </p>
              </div>
              <div className="mt-3 md:mt-0 flex gap-2">
                <button
                  className="bg-gray-200 hover:bg-gray-300 text-sm px-3 py-1 rounded"
                  onClick={() => handleEdit(item)}
                >
                  Edit
                </button>
                <button
                  className="bg-red-500 hover:bg-red-600 text-white text-sm px-3 py-1 rounded"
                  onClick={() => handleDelete(item._id)}
                >
                  Delete
                </button>
              </div>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default DoToDo;
